// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__VGZHF","text":"SelectPayment_text__1HqBt","title":"SelectPayment_title__1USrE","btn":"SelectPayment_btn__1CNz6"};